import { IMyOptions } from '@nodro7/angular-mydatepicker';

export class DatePickerConfig implements IMyOptions {
    showTodayBtn = false;
    firstDayOfWeek = 'mo';
    /** Used internally */
    dateFormat = 'dd.mm.yyyy';
    /**
     * Not an NgxMyDatePicker-Option. We use this in our template.
     */
    displayDateFormat = 'dd.MM.yyyy';
    minYear = 1900;
    maxYear = 2200;
    sunHighlight = false;
}
